export const data = {
  name: "Amit Chaudhary",
  title: "Senior Mobile Engineer",
  tagline: "Available for freelance",
  resumeUrl: "",
  headline: ["Senior Mobile", "Engineer", ""],
  bio: [
    "Hi, I'm Amit — a Senior Mobile Engineer with 6+ years building native iOS and Android applications. I specialize in performance-critical consumer apps, cross-platform solutions, and leading mobile-first engineering teams.",
    "I've worked across startups and enterprise environments, owning entire mobile stacks from architecture decisions to App Store releases. I care deeply about clean code, thoughtful UX, and shipping things that scale.",
    "When I'm not building apps, you'll find me contributing to open source, writing about mobile architecture patterns, or exploring the latest in Jetpack Compose and SwiftUI."
  ],
  stats: [
    { num: "6+", label: "Years of experience" },
    { num: "30+", label: "Apps shipped" },
    { num: "5M+", label: "Users reached" },
  ],
  chips: ["Swift", "Kotlin", "React Native", "Flutter", "SwiftUI", "Jetpack Compose", "Firebase", "CI/CD"],
  skills: [
    { name: "iOS / Swift", sub: "SwiftUI · UIKit · Combine", level: 0.95 },
    { name: "Android / Kotlin", sub: "Jetpack Compose · Coroutines", level: 0.90 },
    { name: "React Native", sub: "Expo · TypeScript · Reanimated", level: 0.85 },
    { name: "Flutter", sub: "Dart · Riverpod · BLoC", level: 0.80 },
    { name: "Backend / Cloud", sub: "Firebase · AWS · Node.js", level: 0.75 },
    { name: "Architecture", sub: "MVVM · Clean · TDD", level: 0.92 },
  ],
  projects: [
    {
      tag: "iOS · Swift",
      title: "Finova — Personal Finance",
      desc: "A beautifully designed budgeting app for iOS with real-time transaction sync, ML-powered spending insights, and end-to-end encryption. Reached #4 in Finance on the App Store.",
      stack: ["Swift", "SwiftUI", "Core Data", "Plaid API"],
      link: "#",
    },
    {
      tag: "Android · Kotlin",
      title: "TrailMate — Outdoor Companion",
      desc: "Offline-first hiking app with GPX route recording, live weather overlays, and a social layer for sharing trail reports. 200k+ active users across 40 countries.",
      stack: ["Kotlin", "Jetpack Compose", "Room", "Maps SDK"],
      link: "#",
    },
    {
      tag: "React Native · Cross-platform",
      title: "Shipd — Logistics Platform",
      desc: "B2B logistics app for real-time shipment tracking and driver management. Built the entire mobile experience solo in 4 months, supporting 15k daily active couriers.",
      stack: ["React Native", "TypeScript", "GraphQL", "Expo"],
      link: "#",
    },
    {
      tag: "Flutter · Cross-platform",
      title: "MindSpace — Wellness App",
      desc: "Mental wellness app featuring guided meditations, mood tracking, and AI-driven journaling prompts. Grew to 80k users organically with a 4.8★ rating.",
      stack: ["Flutter", "Dart", "Firebase", "Riverpod"],
      link: "#",
    },
    {
      tag: "iOS · Open Source",
      title: "SwiftRouter — Navigation Lib",
      desc: "A lightweight, type-safe navigation library for SwiftUI apps with deep-link support. 1.2k GitHub stars and actively maintained.",
      stack: ["Swift", "SwiftUI", "SPM"],
      link: "#",
    },
    {
      tag: "Android · Enterprise",
      title: "PulseHR — HR Platform",
      desc: "Enterprise HR mobile suite for a Fortune 500 client — self-service, leave management, push notifications. Served 50k+ employees across 12 offices.",
      stack: ["Kotlin", "MVVM", "Retrofit", "WorkManager"],
      link: "#",
    },
  ],
  experience: [
    {
      period: "Jan 2026 – Present",
      company: "Novelty Technology",
      role: "Sr. Software Engineer - II",
      desc: "Lead mobile development across iOS and Android for a fintech platform with 2M+ users. Own architecture decisions, code reviews, and mentoring a team of 4 junior engineers.",
      achievements: [
        "Reduced app startup time by 60% through lazy loading and image caching optimisation",
        "Architected a shared component library adopted across 3 product teams",
        "Led migration from REST to GraphQL, cutting API latency by 40%",
      ],
    },
    {
      period: "July 2022 – Dec 2025",
      company: "NAXA",
      role: "Sr. Mobile App Developer",
      desc: "Full-stack mobile role at a product studio delivering apps for clients across fintech, health, and logistics verticals. Contributed to 12 app launches in 3 years.",
      achievements: [
        "Built and shipped 3 cross-platform React Native apps end-to-end",
        "Established CI/CD pipelines with GitHub Actions and Fastlane",
        "Integrated payment flows (Stripe, Apple Pay, Google Pay) across multiple apps",
      ],
    },
    {
      period: "Jan 2020 – Jun 2022",
      company: "Casper India",
      role: "Flutter Developer",
      desc: "First mobile hire at an early-stage startup. Owned the iOS app from zero to 50k users, iterating rapidly based on user feedback and A/B testing results.",
      achievements: [
        "Grew app to 50k downloads within 6 months of launch",
        "Integrated push notification system increasing daily retention by 22%",
        "Collaborated directly with founders and designers on mobile product strategy",
      ],
    },
  ],
  contact: {
    email: "amit@mocklify.dev",
    linkedin: "linkedin.com/in/itheamc",
    github: "github.com/itheamc",
  },
};
